module.exports = __webpack_public_path__ + "static/img/box-close.5d84a418.png";